import { GENDERS } from '@common-types/genders';
import type { NewsletterState } from '@common/Checkout/Checkout/types/newsletter';
import type { NewsletterReducer } from '@common/Checkout/Checkout/types/reducers';
import {
    RECEIVE_NEWSLETTER,
    SET_NEWSLETTER_SUBSCRIPTION_GENDER,
    SET_NEWSLETTER_SUBSCRIPTION_KIDS_PREFERENCE, TOGGLE_CLUB_SIGNUP,
    TOGGLE_CROSS_NEWSLETTER_SUBSCRIPTION,
    TOGGLE_NEWSLETTER_SUBSCRIPTION,
    TOGGLE_SOFT_OPT_IN_NEWSLETTER_SUBSCRIPTION,
} from '../actions/constants';

const initialState: NewsletterState = {
    subscription: false,
    subscriptionSoftOptIn: false,
    kidsPreference: false,
    crossWebshop: false,
    clubSignUp: false,
    gender: GENDERS.UNKNOWN,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer: NewsletterReducer = (state = initialState, action) => {
    const { type } = action;

    switch (type) {
        case RECEIVE_NEWSLETTER: {
            const { payload } = action;
            return { ...state, ...payload };
        }

        case TOGGLE_NEWSLETTER_SUBSCRIPTION: {
            const { payload } = action;

            return { ...state, subscription: payload };
        }

        case TOGGLE_CLUB_SIGNUP: {
            const { payload } = action;

            return { ...state, clubSignUp: payload };
        }

        case SET_NEWSLETTER_SUBSCRIPTION_GENDER: {
            const { payload } = action;

            return { ...state, gender: payload };
        }

        case SET_NEWSLETTER_SUBSCRIPTION_KIDS_PREFERENCE: {
            const { payload } = action;

            return { ...state, kidsPreference: payload };
        }

        case TOGGLE_CROSS_NEWSLETTER_SUBSCRIPTION: {
            const { payload } = action;

            return { ...state, crossWebshop: payload };
        }

        case TOGGLE_SOFT_OPT_IN_NEWSLETTER_SUBSCRIPTION: {
            const { payload } = action;

            return { ...state, subscriptionSoftOptIn: payload };
        }

        default:
            return state;
    }
};

export default reducer;
